/**
 * description: 图片视频上传——个人素材库选择文件服务
 * created by he.zhikai
 * created on 2017.08.10
 */
 "use strict";
 angular.module('personalFileServiceModule', ["personalFileModule"])
    .factory('personalFileService', ["$modal", function($modal) {
    return {
        openPersonalFile: function(fileType, success) {
            var modalInstance = $modal.open({
                templateUrl: "./components/service/personalFileModal/personalFile_tpl.html",
                windowClass: "personal-file",
                backdrop: false,
                controller: "personalFileCtrl",
                resolve: {
                    fileType: function() {
                        return fileType;
                    }
                }
            });
            return modalInstance.result.then(function(data) {
                if(angular.isFunction(success)) {
                    success(data);
                }
            });
        }
    };
 }]);

